import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import app from './modules/app';
import getters from './getters';

Vue.use(Vuex);

var store = new Vuex.Store({
  modules: {
    app: app,
    user: user
  },
  getters: getters
});

export default store;